import type { PremiumDueNotice } from '@/types/premiumDueNotice'
import type { RequestState } from '@/utils/restStore'
import { RequestStatus, handleRequest, initialRequestState } from '@/utils/restStore'
import { defineStore } from 'pinia'

import Api from '@/services/api'

interface State {
  premiumDueNotices: RequestState<PremiumDueNotice[]>
}

const initialState = (): State => ({
  premiumDueNotices: initialRequestState()
})

export const usePremiumDueNoticesStore = defineStore({
  id: 'premium-due-notices',
  state: initialState,
  actions: {
    async fetchPremiumDueNotices(contractNumber: string) {
      await handleRequest(
        () => Api.getPremiumDueNotices(contractNumber),
        (premiumDueNotices: RequestState<PremiumDueNotice[]>) => {
          this.premiumDueNotices = premiumDueNotices
        }
      )
    }
  },
  getters: {
    sortedPremiumDueNotices: (state: State): PremiumDueNotice[] => {
      return state.premiumDueNotices.status === RequestStatus.RequestLoaded
        ? state.premiumDueNotices.data.slice().sort((a, b) => {
            if (a.endDate > b.endDate) return -1
            else if (a.endDate < b.endDate) return 1
            else return 0
          })
        : []
    }
  }
})
